import React from 'react';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
interface StakeProps {
    activeStep: number;
    setActiveStep: (step: number) => void;
    onBack: () => void;
}
const Stake: React.FC<StakeProps> = ({ activeStep, setActiveStep, onBack }) => {
    const handleNextStep = () => {
        if (activeStep < 3) {
            setActiveStep(activeStep + 1);
        }
    };
    return (
        <div className="stake">
            {activeStep === 1 && <StepOne onNext={handleNextStep} />}
            {activeStep === 2 && <StepTwo onNext={handleNextStep} />}
            {activeStep === 3 && <StepThree />}
        </div>
    );
};
export default Stake;
